// Libs
import { createAsyncThunk } from '@reduxjs/toolkit';
// Others
import reviewApi from '~/apis/review';
import { CREATE_REPLY, CREATE_REVIEW, GET_REVIEW_LIST } from '~/utils/constants/actionType';
import { IQueryParamBase } from '~/utils/interface/common';
import { IFormReply, IFormReview } from '~/utils/interface/review';

export const getReviewList = createAsyncThunk(
  GET_REVIEW_LIST,
  async (params: IQueryParamBase, { rejectWithValue }) => {
    try {
      const resp = await reviewApi.getReview(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createReview = createAsyncThunk(
  CREATE_REVIEW,
  async (body: IFormReview, { rejectWithValue }) => {
    try {
      const resp = await reviewApi.createReview(body);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createReply = createAsyncThunk(CREATE_REPLY, async (body: IFormReply, { rejectWithValue }) => {
  try {
    const resp = await reviewApi.createReply(body);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});
